import bannerImg from './banners/woman-helping-man-gym.jpg';

const consultoriaNutricionalInicial = (t) => ({
    id: 'consultoria-nutricional-inicial',
    title: t('templates.items.consultoriaNutricionalInicial.title'),
    description: t('templates.items.consultoriaNutricionalInicial.description'),
    indicatedFor: t('templates.audiences.nutritionists'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.consultoriaNutricionalInicial.summary.nutritionGoal'),
        t('templates.items.consultoriaNutricionalInicial.summary.dietaryRestrictions'),
        t('templates.items.consultoriaNutricionalInicial.summary.healthHistory'),
        t('templates.items.consultoriaNutricionalInicial.summary.currentRoutine'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.consultoriaNutricionalInicial.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.consultoriaNutricionalInicial.form.goals.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.consultoriaNutricionalInicial.form.goals.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.consultoriaNutricionalInicial.form.goals.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.consultoriaNutricionalInicial.form.goals.mainGoal.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'choices',
                        label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.options.none') },
                                { id: 'opt-2', label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.options.lactose') },
                                { id: 'opt-3', label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.options.gluten') },
                                { id: 'opt-4', label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.options.vegetarian') },
                                { id: 'opt-5', label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.options.allergy') },
                                { id: 'opt-6', label: t('templates.items.consultoriaNutricionalInicial.form.goals.restrictions.options.other') },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.consultoriaNutricionalInicial.form.health.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.consultoriaNutricionalInicial.form.health.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: t('templates.items.consultoriaNutricionalInicial.form.health.condition.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.consultoriaNutricionalInicial.form.health.routine.label'),
                        description: t('templates.items.consultoriaNutricionalInicial.form.health.routine.description'),
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'weight',
                        label: t('templates.items.consultoriaNutricionalInicial.form.health.currentWeight.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default consultoriaNutricionalInicial;
